// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DocumentUploadRequestModel {
    static getAttributeTypeMap() {
        return DocumentUploadRequestModel.attributeTypeMap;
    }
}
DocumentUploadRequestModel.discriminator = undefined;
DocumentUploadRequestModel.additionalProperties = false;
DocumentUploadRequestModel.attributeTypeMap = [
    {
        "name": "documentData",
        "baseName": "documentData",
        "type": "string"
    },
    {
        "name": "documentType",
        "baseName": "documentType",
        "type": "DocumentType"
    },
    {
        "name": "identifierText",
        "baseName": "identifierText",
        "type": "string"
    },
];
//# sourceMappingURL=documentUploadRequestModel.js.map